import {Component, OnInit} from '@angular/core';
import {CustomerRegistrationService} from '../../services/customer-registration/customer-registration.service';
import {UserService} from '../../services/user/user.service';
import {UserProfileService} from 'src/app/services/user-profile/user-profile.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {DataService} from '../../services/data.service';
import {CommonValidators} from '../../shared/common-components/common-validators';


@Component({
    selector: 'app-new-okta-user',
    templateUrl: './new-okta-user.component.html',
    styleUrls: ['./new-okta-user.component.css'],
    standalone: false
})
export class NewOktaUserComponent implements OnInit {
  newOktaUserForm: UntypedFormGroup;
  userId: any = 0;
  private tmssloader;
  message: any = '';
  oktaUserApplications: any = null;
  user: any = null;
  securityQuestion: any;
  disabled = true;
  registrationSuccessful = false;
  registrationFailed = false;
  isContainApps: boolean;
  containAppsMessage: string = null;
  isUserAlreadyExists: boolean;
  userAlreadyExistsMessage: string = null;



  constructor(private userService: UserService,
              private userProfileService: UserProfileService,
              private customerRegistrationService: CustomerRegistrationService,
              private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private loader: LoadingService,
              private dataService: DataService,
              private route: ActivatedRoute,
              private router: Router) {

  }

  ngOnInit() {
    this.tmssloader = this.loader;
    this.createForm();
    this.userId = this.route.snapshot.queryParamMap.get('userId');
    console.log('this.userId : ', this.userId);
    this.containAppsMessage = null;
    this.isContainApps = false;
    this.isUserAlreadyExists = false;
    this.userAlreadyExistsMessage = null;
    this.userProfileService.getUserAccountSetup(this.userId).subscribe(oktaUserApplications => {
      this.oktaUserApplications = oktaUserApplications;
      this.user = oktaUserApplications.userEntity;
      this.newOktaUserForm.get('email').setValue(this.user?.email);
      this.newOktaUserForm.get('firstName').setValue(this.user?.firstName);
      this.newOktaUserForm.get('lastName').setValue(this.user?.lastName);
      if (this.oktaUserApplications?.oktaApps != null) {
        const index = this.oktaUserApplications.oktaApps.findIndex(okatApp => okatApp === 'TMSS');
        if (index > -1) {
          this.userAlreadyExistsMessage = 'User already exists. Please login to TMSS.';
          this.isUserAlreadyExists = true;
        } 
      }else {
        console.log('Successfully Retrieved User: ', this.oktaUserApplications);
        if (this.oktaUserApplications.oktaApps != null && this.oktaUserApplications.oktaApps.length > 0) {
          this.containAppsMessage = 'User got access to following apps: ' + this.oktaUserApplications.oktaApps;
          this.isContainApps = true;
        }
      }
      this.tmssloader.hide();
    }, (error) => {
      console.log('There was an error retrieving User Information' + JSON.stringify(error));
      this.alertService.error('There was an error retrieving User Info');
    });
  }


  createForm() {
    const passwordFormControl: UntypedFormControl = new UntypedFormControl('', Validators.required);
    this.newOktaUserForm = this.fb.group({
      firstName: new UntypedFormControl(''),
      lastName: new UntypedFormControl(''),
      email: new UntypedFormControl(''),
      newPassword: passwordFormControl,
      confirmPassword: new UntypedFormControl('', [Validators.required, CommonValidators.same(passwordFormControl)]),
      securityQuestion: new UntypedFormControl('null', Validators.required),
      securityAnswer: new UntypedFormControl('', [Validators.required, Validators.minLength(4)])
    });

  }

  changeQuestion() {
    this.securityQuestion = this.newOktaUserForm.get('securityQuestion').value;
    if (this.securityQuestion === 'null') {
      this.disabled = true;
    } else {
      this.disabled = false;
    }

  }

  saveOktaUser(form) {
    // console.log('saveOktaUser...'+this.userId);
    this.tmssloader.show();
    this.user.userId = this.userId;
    this.user.email = this.newOktaUserForm.get('email').value;
    this.user.newPassword = this.newOktaUserForm.get('newPassword').value;
    this.user.secretQuestion = this.newOktaUserForm.get('securityQuestion').value;
    this.user.secretAnswer = this.newOktaUserForm.get('securityAnswer').value;

    // console.log('securityQuestion...' + this.user.securityQuestion);
    // console.log('securityAnswer...' + this.user.securityAnswer);

    this.customerRegistrationService.saveOktaUser(this.user).subscribe(res => {
      console.log('saveOktaUserMessage.......... ', JSON.stringify(res));
      this.message = JSON.stringify(res).replace(/"/g, '');
      console.log('Success.................................' + this.message);
      this.registrationSuccessful = true;
      this.registrationFailed = false;
      // this.alertService.success('successfully updated !');

    }, (error) => {
      this.alertService.error(error.error);
      this.registrationFailed = true;
      this.registrationSuccessful = false;
      this.message = error.error;
      console.log('Error.......... ', error.error);
      this.tmssloader.hide();

    }, () => {
      this.tmssloader.hide();
    });
    window.scroll(0, 0);
    return;
  }


}
